import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {

  connect() {
    if (this.openOnLoad) this.togglePopover();
  }

  togglePopover(event) {
    event && event.preventDefault();
    const popoverWillOpen = !this.popoverIsOpen;
    App.closePopovers();
    popoverWillOpen && this.loadTimeEntriesMenu(this.url);
  }

  loadTimeEntriesMenu(url) {
    xhrRequest(url, 'get').then(({ data }) => this.populatePopover(data));
  }

  populatePopover(data) {
    document.body.append(document.createElementFromString(this.timeEntryPopoverTemplate(data)));
  }

  timeEntryPopoverTemplate({ listHeader, list }) {
    const ctrlr = "time-entry-menu"
    return `
      <div data-controller="${ctrlr}"
        id="time-entry-popover-window"
        class="popover-window with-shadow">
        <div class="popover-header">
          <h3>Time Entries</h3>
          <a href data-action="${ctrlr}#closePopover" class="close"><i class="far fa-times"></i></a>
        </div>

        <!-- To be populated by ajax request -->
        <div data-${ctrlr}-target="subheader" class="popover-subheader">
          ${listHeader}
        </div>

        <!-- To be populated by ajax request -->
        <div data-${ctrlr}-target="body" class="popover-body">
          ${list}
        </div>
      </div>
    `
  }

  //
  // GETTERS AND SETTERS
  //

  get popoverIsOpen() {
    return !!document.querySelector('#time-entry-popover-window');
  }

  get url() {
    return this.data.get('url');
  }

  get openOnLoad() {
    return !!this.data.get("open-on-load");
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/time-entries/time-entry-popover-button-controller.js